/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CrmLeadKanbanKit from "components/CRMComponents/CRMLeadListComponents/CrmLeadKanbanKit/CrmLeadKanbanKitBody";

const CrmLeadKanban = () => {
  useEffect(() => {
    document.title = "CRM Lead Kanban";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <CrmLeadKanbanKit />
    </main>
  );
};

export default CrmLeadKanban;
